import {
  VerificationReducer
} from './verificationSlice';

const emailToVerify = (state: VerificationReducer) => state.verification.emailToVerify;

export const verificationSelectors = {
  emailToVerify,
};
